<template>
  <b-form-group
    label="Tip"
    label-for="lead_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Tip"
      rules="required"
    >
      <v-select
        v-model="dataItem.lead_type"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ModLeadsTypeSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['modLeads/typeList']
    },
    dataItem() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
